
<style lang="less">
	.sv_main {
		padding: 12px 9px;
	}
	.sv_q{
		margin-top: 5px;
		margin-bottom: 19px;
		overflow: inherit !important;
	}
	h5.sv_q_title{
		font-size: 1.1em;
		font-weight: 300;
	}
	input.sv_q_text_root, textarea, select.sv_q_dropdown_control{
		width: 100%;
		padding: 5px 8px;
		border:  1px solid grey;
	}
	.sv_q_matrix{
		width: 100%;
		margin-top: 20px;
		table-layout: fixed;
		font-size: 0.8em;
		td:first-child {
			width: 35%;
			padding-top: 7px;
			padding-bottom:20px;
		}
		th{
			font-weight: 600;
			color: grey;
			padding-left: 14px;
			padding-right: 14px;
		}
		td label.sv_q_m_label{
			text-align: center;
		}
	}
	.sv_q_required_text{
		font-weight: bold;
		color: red;
	}
	.sv_complete_btn{
		height: 36px;
		cursor: pointer;
		min-width: 64px;
		padding: 0 16px;
		background-color: #86bd60 !important;
		border-color: #86bd60 !important;
		text-transform: uppercase;
		color: white !important; 
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		border-radius: 4px;
		-webkit-box-flex: 0;
		-ms-flex: 0 0 auto;
		flex: 0 0 auto;
		font-weight: 500;
		letter-spacing: 0.0892857143em;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		outline: 0;
		position: relative;
		text-decoration: none;
		text-indent: 0.0892857143em;
		text-transform: uppercase;
		-webkit-transition-duration: 0.28s;
		transition-duration: 0.28s;
		-webkit-transition-property: opacity, -webkit-box-shadow, -webkit-transform;
		transition-property: opacity, -webkit-box-shadow, -webkit-transform;
		transition-property: box-shadow, transform, opacity;
		transition-property: box-shadow, transform, opacity, -webkit-box-shadow, -webkit-transform;
		-webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		vertical-align: middle;
		white-space: nowrap;
	}
</style>
<template>
	<survey :survey="surveyModel"></survey>
</template>
<script>
	import * as SurveyVue from "survey-vue";
	// import 'bootstrap-css-only/css/bootstrap.css';
	var Survey = SurveyVue.Survey
	// Survey.cssType = "bootstrap";



	export default {
		name: "RenderSurvey",
		props: [
			"surveyContent",
			"data"
		],
		data:() => {
			return {
				surveyModel: {}
			}
		},
		components:{
			Survey: Survey
		},
		computed: {
			urlParams(){
				const self = this;
				var data = {}
				self.surveyContent.elements.forEach( q => {
					if( q.urlParam ) {
						var u = q.urlParam;					
						if( self.$route.query[u] ){
							data[q.name] = self.$route.query[u];
						}
					}
				})
				return data;
			}
		},
		watch: {
			data: {
				immediate: true, 
				handler() {
					const self = this;
					if( self.data ){
						self.surveyModel.data = self.data;
					}					
				}
			},
			surveyModel: {
				immediate: true, 
				handler(){
					const self = this;
					var urlParams = self.urlParams;
					Object.keys(urlParams).forEach( k => {
						// console.log( k )
						self.surveyModel.setValue(k, urlParams[k] )
					})
				}
			}
		},
		created: function() {
			const self = this;
			let SurveyModel = new SurveyVue.Model(self.surveyContent)
			window.S = SurveyModel;
			SurveyModel.completeText = "Next Step";
			self.surveyModel = SurveyModel;
			SurveyModel.onComplete.add(function (result) {
				self.$emit("complete", result)
			});

			
		}
	}
</script>